import { TextFieldWithEllipsis } from "UI/TextFiledWithEllipsis";

export const locationsColumns = [
  {
    label: "Name",
    field: "name",
    xs: 3,
    sm: 3,
    md: 3,
    renderer: ({ name }) => (
      <TextFieldWithEllipsis>{name}</TextFieldWithEllipsis>
    ),
  },
  {
    label: "Address",
    field: "street",
    xs: 4,
    sm: 4,
    md: 4,
    renderer: ({ street, street2, city, state, zipCode }) => (
      <TextFieldWithEllipsis>
        {[street, street2, city, state, zipCode].filter(Boolean).join(", ")}
      </TextFieldWithEllipsis>
    ),
  },
  {
    label: "Phone",
    field: "phone",
    xs: 2,
    sm: 2,
    md: 2,
    renderer: ({ phone }) => (
      <TextFieldWithEllipsis>{phone}</TextFieldWithEllipsis>
    ),
  },
  {
    label: "Speciality",
    field: "speciality",
    xs: 3,
    sm: 3,
    md: 3,
    renderer: ({ speciality }) => (
      <TextFieldWithEllipsis>{speciality}</TextFieldWithEllipsis>
    ),
  },
];

export const locationsMobileColumns = [
  {
    label: "Name",
    field: "name",
    xs: 4,
    sm: 4,
    md: 4,
    renderer: ({ name }) => (
      <TextFieldWithEllipsis>{name}</TextFieldWithEllipsis>
    ),
  },
  {
    label: "Address",
    field: "street",
    xs: 4,
    sm: 4,
    md: 4,
    renderer: ({ street, street2, city, state, zipCode }) => (
      <TextFieldWithEllipsis>
        {[street, street2, city, state, zipCode].filter(Boolean).join(", ")}
      </TextFieldWithEllipsis>
    ),
  },
  {
    label: "Speciality",
    field: "speciality",
    xs: 4,
    sm: 4,
    md: 4,
    renderer: ({ speciality }) => (
      <TextFieldWithEllipsis>{speciality}</TextFieldWithEllipsis>
    ),
  },
];
